// tslint:disable
/// <reference path="../custom.d.ts" />
/**
 * Reposit API
 * The Reposit API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

import { SearchKpiDocumentResultsDTO } from '../models';
/**
 * KpiDocumentApi - axios parameter creator
 * @export
 */
export const KpiDocumentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Search for Kpi Documents
         * @param {string} from Search to search from
         * @param {string} to Search to search to
         * @param {number} page Page to start on (defaults to 1)
         * @param {number} size Size of result set to return (defaults to 15)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchKpiDocuments(from: string, to: string, page: number, size: number, options: any = {}): RequestArgs {
            // verify required parameter 'from' is not null or undefined
            if (from === null || from === undefined) {
                throw new RequiredError('from','Required parameter from was null or undefined when calling searchKpiDocuments.');
            }
            // verify required parameter 'to' is not null or undefined
            if (to === null || to === undefined) {
                throw new RequiredError('to','Required parameter to was null or undefined when calling searchKpiDocuments.');
            }
            // verify required parameter 'page' is not null or undefined
            if (page === null || page === undefined) {
                throw new RequiredError('page','Required parameter page was null or undefined when calling searchKpiDocuments.');
            }
            // verify required parameter 'size' is not null or undefined
            if (size === null || size === undefined) {
                throw new RequiredError('size','Required parameter size was null or undefined when calling searchKpiDocuments.');
            }
            const localVarPath = `/v2/kpis/documents/search`;
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = to;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * KpiDocumentApi - functional programming interface
 * @export
 */
export const KpiDocumentApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Search for Kpi Documents
         * @param {string} from Search to search from
         * @param {string} to Search to search to
         * @param {number} page Page to start on (defaults to 1)
         * @param {number} size Size of result set to return (defaults to 15)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchKpiDocuments(from: string, to: string, page: number, size: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SearchKpiDocumentResultsDTO>> {
            const localVarAxiosArgs = KpiDocumentApiAxiosParamCreator(configuration).searchKpiDocuments(from, to, page, size, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * KpiDocumentApi - factory interface
 * @export
 */
export const KpiDocumentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Search for Kpi Documents
         * @param {string} from Search to search from
         * @param {string} to Search to search to
         * @param {number} page Page to start on (defaults to 1)
         * @param {number} size Size of result set to return (defaults to 15)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchKpiDocuments(from: string, to: string, page: number, size: number, options?: any) {
            return KpiDocumentApiFp(configuration).searchKpiDocuments(from, to, page, size, options)(axios, basePath);
        },
    };
};

/**
 * KpiDocumentApi - interface
 * @export
 * @interface KpiDocumentApi
 */
export interface KpiDocumentApiInterface {
    /**
     * Search for Kpi Documents
     * @param {string} from Search to search from
     * @param {string} to Search to search to
     * @param {number} page Page to start on (defaults to 1)
     * @param {number} size Size of result set to return (defaults to 15)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KpiDocumentApiInterface
     */
    searchKpiDocuments(from: string, to: string, page: number, size: number, options?: any): AxiosPromise<Array<SearchKpiDocumentResultsDTO>>;

}

/**
 * KpiDocumentApi - object-oriented interface
 * @export
 * @class KpiDocumentApi
 * @extends {BaseAPI}
 */
export class KpiDocumentApi extends BaseAPI implements KpiDocumentApiInterface {
    /**
     * Search for Kpi Documents
     * @param {string} from Search to search from
     * @param {string} to Search to search to
     * @param {number} page Page to start on (defaults to 1)
     * @param {number} size Size of result set to return (defaults to 15)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KpiDocumentApi
     */
    public searchKpiDocuments(from: string, to: string, page: number, size: number, options?: any) {
        return KpiDocumentApiFp(this.configuration).searchKpiDocuments(from, to, page, size, options)(this.axios, this.basePath);
    }

}

/**
 * Standalone tree-shakeable functions for KpiDocumentApi
 * Import individual functions for optimal bundle size
 */
/**
 * Search for Kpi Documents
 * @param {string} from Search to search from
 * @param {string} to Search to search to
 * @param {number} page Page to start on (defaults to 1)
 * @param {number} size Size of result set to return (defaults to 15)
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function searchKpiDocuments(
    from: string,
    to: string,
    page: number,
    size: number,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<Array<SearchKpiDocumentResultsDTO>> {
    const localVarAxiosArgs = KpiDocumentApiAxiosParamCreator(configuration).searchKpiDocuments(from, to, page, size, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

